import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef } from "react";
import { InfiniteScroll } from "../../InfiniteScroll/index.js";
import { CircularProgress } from "../../CircularProgress/index.js";
import { Box } from "../../Box/index.js";
import ListBox_styles from "./ListBox.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ListBox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ListBox_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const ListBox = /*#__PURE__*/ forwardRef((t0, ref)=>{
    const $ = c(24);
    let children;
    let dataLength;
    let hasMore;
    let loading;
    let next;
    let props;
    if ($[0] !== t0) {
        ({ hasMore, dataLength, next, loading, children } = t0), props = _object_without_properties(t0, [
            "hasMore",
            "dataLength",
            "next",
            "loading",
            "children"
        ]);
        $[0] = t0;
        $[1] = children;
        $[2] = dataLength;
        $[3] = hasMore;
        $[4] = loading;
        $[5] = next;
        $[6] = props;
    } else {
        children = $[1];
        dataLength = $[2];
        hasMore = $[3];
        loading = $[4];
        next = $[5];
        props = $[6];
    }
    const { classes } = ListBox_styles();
    let t1;
    if ($[7] !== loading) {
        t1 = loading && /*#__PURE__*/ jsx(Box, {
            display: "flex",
            justifyContent: "center",
            p: "16",
            children: /*#__PURE__*/ jsx(CircularProgress, {
                size: 30
            })
        });
        $[7] = loading;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("div", {});
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== children || $[11] !== classes.listBox) {
        t3 = /*#__PURE__*/ jsx("ul", {
            className: classes.listBox,
            children: children
        });
        $[10] = children;
        $[11] = classes.listBox;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== dataLength || $[14] !== hasMore || $[15] !== next || $[16] !== t1 || $[17] !== t3) {
        t4 = /*#__PURE__*/ jsx(InfiniteScroll, {
            next: next,
            dataLength: dataLength,
            hasMore: hasMore,
            loader: t1,
            endMessage: t2,
            scrollId: "multiple-autocomplete-input-scrollable",
            children: t3
        });
        $[13] = dataLength;
        $[14] = hasMore;
        $[15] = next;
        $[16] = t1;
        $[17] = t3;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== classes.scrollableWrapper || $[20] !== props || $[21] !== ref || $[22] !== t4) {
        t5 = /*#__PURE__*/ jsx("div", _object_spread_props(_object_spread({}, props), {
            id: "multiple-autocomplete-input-scrollable",
            ref: ref,
            className: classes.scrollableWrapper,
            children: t4
        }));
        $[19] = classes.scrollableWrapper;
        $[20] = props;
        $[21] = ref;
        $[22] = t4;
        $[23] = t5;
    } else t5 = $[23];
    return t5;
});
export { ListBox };
